<div class="modal-header">
  <h3>{{ title }}</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body h-100 d-flex flex-column">
  <div class="row">
    <div class="col">
      <ul class="vive-blue_list">
        <li>Click on any row to edit that site.</li>
        <li>
          Rows highlighted in <span class="error-red fw-semibold">RED</span> are
          missing required fields. ({{ missingRequiredDataCount }})
        </li>
        <li>
          Rows highlighted in <span class="yellow fw-semibold">YELLOW</span> are
          sites matching existing sites. ({{ matchingExistingSiteCount }})
        </li>
        <li>
          Rows highlighted in <span class="orange fw-semibold">ORANGE</span> are
          both missing required fields and contain matching site data to
          existing sites. ({{
            bothMissingRequiredFieldsAndMatchingExistingCount
          }})
        </li>
      </ul>
    </div>
  </div>

  <div class="row flex-grow-1" style="min-height: 400px">
    <div class="col">
      <app-sites-grid
        [gridName]="'AdminSitesUpload'"
        [rowModelType]="'clientSide'"
        [gridPrimaryKeyFieldName]="'siteKey'"
        [rowData]="rowData"
        [rowClassRules]="rowClassRules"
        [ColumnIdToColumnActions]="ColumnIdToColumnActions"
        (actionEvent)="actionEvent($event)"
        [(reloadGridData)]="reloadGrid"
      ></app-sites-grid>
    </div>
  </div>
</div>
<div class="modal-footer">
  <div class="col-2">
    <button type="button" class="btn btn-danger h-100" (click)="close()">
      Close
    </button>
  </div>

  <div class="col-2">
    <button type="button" class="btn btn-primary h-100" (click)="upload()">
      Upload
    </button>
  </div>
</div>
